import { render, staticRenderFns } from "./Sushi.vue?vue&type=template&id=3baf04ce&scoped=true&"
import script from "./Sushi.vue?vue&type=script&lang=js&"
export * from "./Sushi.vue?vue&type=script&lang=js&"
import style0 from "./Sushi.vue?vue&type=style&index=0&id=3baf04ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf04ce",
  null
  
)

export default component.exports